// import segmentos from '../views/home/index.vue';
import conteudoExclusivo from '../views/home/conteudoExclusivo'
import landing from '../views/landing/index.vue'
import defaultLanding from '../views/landing/default.vue'
import exclusivo from '@/components/segmento-de-conteudo/segmento-de-conteudo.vue'
import maintenance from '@/components/pages/Maintenance.vue'
/*
 * * Integração API - SUPERPRO  * *
 */
import userIndex from '@/components/pages/solucoes/superpro/usuarios/index.vue'
import schoolIndex from '@/components/pages/solucoes/superpro/escolas/index.vue'

import acessoSuperPro from '@/components/pages/clientes/superProAcessoClientes.vue'
import adminSuperPro from '@/components/pages/solucoes/superpro/index.vue'
import listaEscola from '@/components/pages/solucoes/superpro/escolas/superproListaEscola.vue'
import listaUsuarios from '@/components/pages/solucoes/superpro/usuarios/superproListaUsuarios.vue'
import criaUsuarioSuperPro from '@/components/pages/solucoes/superpro/usuarios/superproCriarUsuario.vue'
import editaUsuarioSuperPro from '@/components/pages/solucoes/superpro/usuarios/superproEditarUsuario.vue'
import excluiUsuarioSuperPro from '@/components/pages/solucoes/superpro/usuarios/superproExcluirUsuario.vue'
import cadastrarEscolaSuperPro from '@/components/pages/solucoes/superpro/escolas/superproCadastrarEscola.vue'
import cadastrarCreditoSuperPro from '@/components/pages/solucoes/superpro/usuarios/superproCadastrarCredito.vue'
import consultarCreditoSuperPro from '@/components/pages/solucoes/superpro/usuarios/superproConsultarCredito.vue'
import extornarCreditoSuperPro from '@/components/pages/solucoes/superpro/usuarios/superproEstornarCredito.vue'
import extornarCreditoEscolaSuperPro from '@/components/pages/solucoes/superpro/escolas/superproEstornarCredEscola.vue'
import atendimentoDigital from '@/components/pages/clientes/atendimentoDigital.vue'
import lincarUsuarioSpwSuperPro from '@/components/pages/solucoes/superpro/vincularUsuario.vue'

/*
 * * Coleção Infantil  * *
 */
import dashInfantil from '@/components/segmento-de-conteudo/infantil/DashInfantil.vue'
import cadernoDigitalInfantil from '@/components/segmento-de-conteudo/infantil/CadernoDigitalInfantil.vue'
// import programacaoInfantil from '@/components/segmento-de-conteudo/infantil/ProgramacaoInfantil.vue';
// import manualInfantil from '@/components/segmento-de-conteudo/infantil/ManualInfantil.vue';
import musicasVideos from '@/components/segmento-de-conteudo/infantil/musicasVideos.vue'
import flashCards from '@/components/segmento-de-conteudo/infantil/cadernoDigital/flashCards.vue'
import InfantilII from '@/components/segmento-de-conteudo/infantil/cadernoDigital/infantil-II.vue'
import InfantilIII from '@/components/segmento-de-conteudo/infantil/cadernoDigital/infantil-III.vue'
import InfantilIV from '@/components/segmento-de-conteudo/infantil/cadernoDigital/infantil-IV.vue'
import InfantilV from '@/components/segmento-de-conteudo/infantil/cadernoDigital/infantil-V.vue'
import Programacao from '@/components/segmento-de-conteudo/infantil/programacao.vue'
import Manual from '@/components/segmento-de-conteudo/infantil/manual.vue'
import MaternalI from '@/components/segmento-de-conteudo/infantil/manual/maternal-i.vue'
import MaternalII from '@/components/segmento-de-conteudo/infantil/manual/maternal-ii.vue'
import JardimI from '@/components/segmento-de-conteudo/infantil/manual/jardim-i.vue'
import JardimII from '@/components/segmento-de-conteudo/infantil/manual/jardim-ii.vue'
import MusicaMaternalI from '@/components/segmento-de-conteudo/infantil/musicas/maternal-i.vue'
import MusicaMaternalII from '@/components/segmento-de-conteudo/infantil/musicas/maternal-ii.vue'
import MusicaJardimI from '@/components/segmento-de-conteudo/infantil/musicas/jardim-i.vue'
import MusicaJardimII from '@/components/segmento-de-conteudo/infantil/musicas/jardim-ii.vue'

/*
 * * Coleção Fundamental 1  * *
 */
import dashFund1 from '@/components/segmento-de-conteudo/fundamental_1/DashFund1.vue'
import CadernoDigital from '@/components/segmento-de-conteudo/fundamental_1/CadernoDigitalFund1'
import primeiroAno from '@/components/segmento-de-conteudo/fundamental_1/cadernoDigital/primeiroAno'
import simuladosFund1 from '@/components/segmento-de-conteudo/fundamental_1/SimuladosFund1.vue'
import programacaoFundI from '@/components/segmento-de-conteudo/fundamental_1/ProgramacaoFundamental1.vue'
import manualFundI from '@/components/segmento-de-conteudo/fundamental_1/ManualFund1.vue'
import SegundoAno from '@/components/segmento-de-conteudo/fundamental_1/cadernoDigital/segundoAno.vue'
import terceiroAno from '@/components/segmento-de-conteudo/fundamental_1/cadernoDigital/terceiroAno.vue'
import quartoAno from '@/components/segmento-de-conteudo/fundamental_1/cadernoDigital/quartoAno.vue'
import quintoAno from '@/components/segmento-de-conteudo/fundamental_1/cadernoDigital/quintoAno.vue'
import materialComplementarFund1 from '@/components/segmento-de-conteudo/fundamental_1/cadernoDigital/materialComplementar.vue'
import simuladosFund1_2Ano from '@/components/segmento-de-conteudo/fundamental_1/simulados/segundoAno.vue'
import simuladosFund1_3Ano from '@/components/segmento-de-conteudo/fundamental_1/simulados/terceiroAno.vue'
import simuladosFund1_4Ano from '@/components/segmento-de-conteudo/fundamental_1/simulados/quartoAno.vue'
import simuladosFund1_5Ano from '@/components/segmento-de-conteudo/fundamental_1/simulados/quintoAno.vue'
import manual1Ano from '@/components/segmento-de-conteudo/fundamental_1/manual/primeiroAno.vue'
import manual2Ano from '@/components/segmento-de-conteudo/fundamental_1/manual/segundoAno.vue'
import manual3Ano from '@/components/segmento-de-conteudo/fundamental_1/manual/terceiroAno.vue'
import manual4Ano from '@/components/segmento-de-conteudo/fundamental_1/manual/quartoAno.vue'
import manual5Ano from '@/components/segmento-de-conteudo/fundamental_1/manual/quintoAno.vue'

import musicaFundI from '@/components/segmento-de-conteudo/fundamental_1/musica_video.vue'
import musica1oAno from '@/components/segmento-de-conteudo/fundamental_1/musicas/primeiroAno.vue'
import musica2oAno from '@/components/segmento-de-conteudo/fundamental_1/musicas/segundoAno.vue'
import musica3oAno from '@/components/segmento-de-conteudo/fundamental_1/musicas/terceiroAno.vue'
import musica4oAno from '@/components/segmento-de-conteudo/fundamental_1/musicas/quartoAno.vue'
import musica5oAno from '@/components/segmento-de-conteudo/fundamental_1/musicas/quintoAno.vue'

/*
 * * Coleção Fundamental 2 * *
 */
import dashFund2 from '@/components/segmento-de-conteudo/fundamental_2/DashFund2.vue'
import fundIIColecao from '@/components/segmento-de-conteudo/fundamental_2/CadernoDigitalFund2'
import fundIIColecaoSexto from '@/components/segmento-de-conteudo/fundamental_2/ColecaoCPV/sextoAno.vue'
import fundIIColecaoSetimo from '@/components/segmento-de-conteudo/fundamental_2/ColecaoCPV/setimoAno.vue'
import fundIIColecaoOitavo from '@/components/segmento-de-conteudo/fundamental_2/ColecaoCPV/oitavoAno.vue'
import fundIIColecaoNono from '@/components/segmento-de-conteudo/fundamental_2/ColecaoCPV/nonoAno.vue'
import fundIIColecaoEspanhol from '@/components/segmento-de-conteudo/fundamental_2/ColecaoCPV/materialEspanhol.vue'
import fundIIColecaoIngles from '@/components/segmento-de-conteudo/fundamental_2/ColecaoCPV/materialUS.vue'
import fundIISimulados from '@/components/segmento-de-conteudo/fundamental_2/SimuladosFund2.vue'
import fundIISimuladosSexto from '@/components/segmento-de-conteudo/fundamental_2/Simulados/sextoAno.vue'
import fundIISimuladosSetimo from '@/components/segmento-de-conteudo/fundamental_2/Simulados/setimoAno.vue'
import fundIISimuladosOitavo from '@/components/segmento-de-conteudo/fundamental_2/Simulados/oitavoAno.vue'
import fundIISimuladosNono from '@/components/segmento-de-conteudo/fundamental_2/Simulados/nonoAno.vue'
import fundIIProgramacao from '@/components/segmento-de-conteudo/fundamental_2/ProgramacaoFundamental2.vue'
import fundIIManual from '@/components/segmento-de-conteudo/fundamental_2/ManualFund2.vue'
import fundIIManualSexto from '@/components/segmento-de-conteudo/fundamental_2/Manual/sextoAno.vue'
import fundIIManualSetimo from '@/components/segmento-de-conteudo/fundamental_2/Manual/setimoAno.vue'
import fundIIManualOitavo from '@/components/segmento-de-conteudo/fundamental_2/Manual/oitavoAno.vue'
import fundIIManualNono from '@/components/segmento-de-conteudo/fundamental_2/Manual/nonoAno.vue'

import fundIIProjetoInterdisciplinar from '@/components/segmento-de-conteudo/fundamental_2/projetosInterdisciplinares.vue'

/*
 * * Coleção Ensino Médio * *
 */
import dashEnsinoMedio from '@/components/segmento-de-conteudo/ensino_medio/DashEnsinoMedio.vue'
import cadernoDigitalEnsinoMedio from '@/components/segmento-de-conteudo/ensino_medio/CadernoDigitalEnsinoMedio.vue'
import primeiroAnoEM from '@/components/segmento-de-conteudo/ensino_medio/ColecaoCPV/primeiraAno.vue'
import segundoAnoEM from '@/components/segmento-de-conteudo/ensino_medio/ColecaoCPV/segundoAno.vue'
import terceiroAnoEM from '@/components/segmento-de-conteudo/ensino_medio/ColecaoCPV/terceiroAno.vue'
import materialComplementarEM from '@/components/segmento-de-conteudo/ensino_medio/ColecaoCPV/materialComplementar.vue'
import programacaoEnsinoMedio from '@/components/segmento-de-conteudo/ensino_medio/ProgramacaoEnsinoMedio.vue'
import manualEnsinoMedio from '@/components/segmento-de-conteudo/ensino_medio/ManualEnsinoMedio.vue'
import primeiroAnoManualEM from '@/components/segmento-de-conteudo/ensino_medio/Manual/primeiroAno.vue'
import segundoAnoManualEM from '@/components/segmento-de-conteudo/ensino_medio/Manual/segundoAno.vue'
import terceiroAnoManualEM from '@/components/segmento-de-conteudo/ensino_medio/Manual/terceiroAno.vue'
import aulasDigitaisEnsinoMedio from '@/components/segmento-de-conteudo/ensino_medio/AulasDigitaisEnsinoMedio.vue'
import aulaDigitalQuimicaEM from '@/components/segmento-de-conteudo/ensino_medio/AulasDigitais/quimica.vue'
import aulaDigitalBiologiaEM from '@/components/segmento-de-conteudo/ensino_medio/AulasDigitais/biologia.vue'
import aulaDigitalfisicaEM from '@/components/segmento-de-conteudo/ensino_medio/AulasDigitais/fisica.vue'
import aulaDigitalgeografiaEM from '@/components/segmento-de-conteudo/ensino_medio/AulasDigitais/geografia.vue'
import aulaDigitalhistoriaEM from '@/components/segmento-de-conteudo/ensino_medio/AulasDigitais/historia.vue'
import aulaDigitalLpEM from '@/components/segmento-de-conteudo/ensino_medio/AulasDigitais/linguaPortuguesa.vue'
import aulaDigitalLiteraturaEM from '@/components/segmento-de-conteudo/ensino_medio/AulasDigitais/literatura.vue'
import aulaDigitalmatematicaEM from '@/components/segmento-de-conteudo/ensino_medio/AulasDigitais/matematica.vue'
import aulaDigitalPrgBaseEM from '@/components/segmento-de-conteudo/ensino_medio/AulasDigitais/programacaoEMBase.vue'
import aulaDigitalRedacaoEM from '@/components/segmento-de-conteudo/ensino_medio/AulasDigitais/redacao.vue'
import resolucoesEnsinoMedio from '@/components/segmento-de-conteudo/ensino_medio/ResolucoesEnsinoMedio.vue'
import resolucoesMTEnsinoMedio from '@/components/segmento-de-conteudo/ensino_medio/Resolucoes/matematica.vue'
import resolucoesFSEnsinoMedio from '@/components/segmento-de-conteudo/ensino_medio/Resolucoes/fisica.vue'
import caderno1ResolucoesMatematica from '@/components/segmento-de-conteudo/ensino_medio/Resolucoes/matematica/cadernoUm.vue'
import caderno2ResolucoesMatematica from '@/components/segmento-de-conteudo/ensino_medio/Resolucoes/matematica/cadernoDois.vue'
import caderno3ResolucoesMatematica from '@/components/segmento-de-conteudo/ensino_medio/Resolucoes/matematica/cadernoTres.vue'
import caderno4ResolucoesMatematica from '@/components/segmento-de-conteudo/ensino_medio/Resolucoes/matematica/cadernoQuatro.vue'
import caderno5ResolucoesMatematica from '@/components/segmento-de-conteudo/ensino_medio/Resolucoes/matematica/cadernoCinco.vue'
import caderno6ResolucoesMatematica from '@/components/segmento-de-conteudo/ensino_medio/Resolucoes/matematica/cadernoSeis.vue'
import caderno7ResolucoesMatematica from '@/components/segmento-de-conteudo/ensino_medio/Resolucoes/matematica/cadernoSete.vue'
import caderno8ResolucoesMatematica from '@/components/segmento-de-conteudo/ensino_medio/Resolucoes/matematica/cadernoOito.vue'
import caderno9ResolucoesMatematica from '@/components/segmento-de-conteudo/ensino_medio/Resolucoes/matematica/cadernoNove.vue'
import caderno10ResolucoesMatematica from '@/components/segmento-de-conteudo/ensino_medio/Resolucoes/matematica/cadernoDez.vue'
import caderno1ResolucoesQuimica from '@/components/segmento-de-conteudo/ensino_medio/Resolucoes/quimica/cadernoUm.vue'
import caderno2ResolucoesQuimica from '@/components/segmento-de-conteudo/ensino_medio/Resolucoes/quimica/cadernoDois.vue'
import caderno3ResolucoesQuimica from '@/components/segmento-de-conteudo/ensino_medio/Resolucoes/quimica/cadernoTres.vue'
import caderno4ResolucoesQuimica from '@/components/segmento-de-conteudo/ensino_medio/Resolucoes/quimica/cadernoQuatro.vue'
import caderno5ResolucoesQuimica from '@/components/segmento-de-conteudo/ensino_medio/Resolucoes/quimica/cadernoCinco.vue'
import caderno6ResolucoesQuimica from '@/components/segmento-de-conteudo/ensino_medio/Resolucoes/quimica/cadernoSeis.vue'
import caderno7ResolucoesQuimica from '@/components/segmento-de-conteudo/ensino_medio/Resolucoes/quimica/cadernoSete.vue'
import caderno8ResolucoesQuimica from '@/components/segmento-de-conteudo/ensino_medio/Resolucoes/quimica/cadernoOito.vue'
import caderno9ResolucoesQuimica from '@/components/segmento-de-conteudo/ensino_medio/Resolucoes/quimica/cadernoNove.vue'
import caderno10ResolucoesQuimica from '@/components/segmento-de-conteudo/ensino_medio/Resolucoes/quimica/cadernoDez.vue'
import resolucoesQMEnsinoMedio from '@/components/segmento-de-conteudo/ensino_medio/Resolucoes/quimica.vue'
import ProjetosInterdisciplinaresEM from '@/components/segmento-de-conteudo/ensino_medio/ProjetoInterdisciplinar.vue'
import exerciciosRegionaisEnsinoMedio from '@/components/segmento-de-conteudo/ensino_medio/ExerciciosRegionaisEnsinoMedio.vue'
import exerciciosRegionaisMinasGerais from '@/components/segmento-de-conteudo/ensino_medio/ex_regionais/minas_gerais.vue'
import exerciciosRegionaisRioDeJaneiro from '@/components/segmento-de-conteudo/ensino_medio/ex_regionais/rio_de_janeiro.vue'
import exerciciosRegionaisSul from '@/components/segmento-de-conteudo/ensino_medio/ex_regionais/sul.vue'

/*
 * * Coleção Pre-Vestibular * *
 */
import dashPreVestibular from '@/components/segmento-de-conteudo/pre-vestibular/DashPreVestibular'
import programacaoPreVestibular from '@/components/segmento-de-conteudo/pre-vestibular/ProgramacaoPreVestibular.vue'
import manualPreVestibular from '@/components/segmento-de-conteudo/pre-vestibular/ManualPreVestibular.vue'
import resolucoesPreVestibular from '@/components/segmento-de-conteudo/pre-vestibular/ResolucoesPreVestibular.vue'
import resolucoesPreVestibularMatematica from '@/components/segmento-de-conteudo/pre-vestibular/resolucoes/matematica.vue'
import resoPreVestibularCaderno2Matematica from '@/components/segmento-de-conteudo/pre-vestibular/resolucoes/matematica/cadernoDois.vue'
import resoPreVestibularCaderno3Matematica from '@/components/segmento-de-conteudo/pre-vestibular/resolucoes/matematica/cadernoTres.vue'
import resoPreVestibularCaderno4Matematica from '@/components/segmento-de-conteudo/pre-vestibular/resolucoes/matematica/cadernoQuatro.vue'
import resoPreVestibularCaderno5Matematica from '@/components/segmento-de-conteudo/pre-vestibular/resolucoes/matematica/cadernoCinco.vue'
import resoPreVestibularCaderno6Matematica from '@/components/segmento-de-conteudo/pre-vestibular/resolucoes/matematica/cadernoSeis.vue'
import resoPreVestibularCaderno7Matematica from '@/components/segmento-de-conteudo/pre-vestibular/resolucoes/matematica/cadernoSete.vue'
import resoPreVestibularCaderno8Matematica from '@/components/segmento-de-conteudo/pre-vestibular/resolucoes/matematica/cadernoOito.vue'
import exerciciosRegionaisPreVestibular from '@/components/segmento-de-conteudo/pre-vestibular/ExerciciosRegionaisPreVestibular.vue'
import cadernoExRegionaisMinasPre from '@/components/segmento-de-conteudo/pre-vestibular/ex_regionais/minas_gerais.vue'
import cadernoExRegionaisRioPre from '@/components/segmento-de-conteudo/pre-vestibular/ex_regionais/rio_de_janeiro.vue'
import cadernoExRegionaisSulPre from '@/components/segmento-de-conteudo/pre-vestibular/ex_regionais/sul.vue'

/*
 * * Coleção ENEM * *
 */
import dashEnem from '@/components/segmento-de-conteudo/enem/DashEnem.vue'
import cadernoDigitalEnem from '@/components/segmento-de-conteudo/enem/CadernoDigitalEnem.vue'
import estatisticasEnem from '@/components/segmento-de-conteudo/enem/EstatisticasEnem.vue'
import manualEnem from '@/components/segmento-de-conteudo/enem/ManualEnem.vue'

/*
 * * Banco de livros * *
 */
import books from '@/components/segmento-de-conteudo/banco_livros/Books.vue'
/* Infantil */
import booksInfantil from '@/components/segmento-de-conteudo/banco_livros/infantil.vue'
/* Fundamental I */
import booksFundamentalI from '@/components/segmento-de-conteudo/banco_livros/fundamental-I.vue'
import booksFundamentalIPrimeiroAno from '@/components/segmento-de-conteudo/banco_livros/fundamental-i/primeiro-ano.vue'
import booksFundamentalISegundoAno from '@/components/segmento-de-conteudo/banco_livros/fundamental-i/segundo-ano.vue'
import booksFundamentalITerceiroAno from '@/components/segmento-de-conteudo/banco_livros/fundamental-i/terceiro-ano.vue'
import booksFundamentalIQuartoAno from '@/components/segmento-de-conteudo/banco_livros/fundamental-i/quarto-ano.vue'
import booksFundamentalIQuintoAno from '@/components/segmento-de-conteudo/banco_livros/fundamental-i/quinto-ano.vue'
import booksFundamentalII from '@/components/segmento-de-conteudo/banco_livros/fundamental-II.vue'
import booksFundamentalIISextoAno from '@/components/segmento-de-conteudo/banco_livros/fundamental-ii/sexto-ano.vue'
import booksFundamentalIISetimoAno from '@/components/segmento-de-conteudo/banco_livros/fundamental-ii/setimo-ano.vue'
import booksFundamentalIIOitavoAno from '@/components/segmento-de-conteudo/banco_livros/fundamental-ii/oitavo-ano.vue'
import booksFundamentalIINonoAno from '@/components/segmento-de-conteudo/banco_livros/fundamental-ii/nono-ano.vue'
import booksEnsinoMedio from '@/components/segmento-de-conteudo/banco_livros/ensinoMedio.vue'
import booksEnsinoMedioPrimeiroAno from '@/components/segmento-de-conteudo/banco_livros/ensinoMedio/primeiro-ano.vue'
import booksEnsinoMedioSegundoAno from '@/components/segmento-de-conteudo/banco_livros/ensinoMedio/segundo-ano.vue'
import booksEnsinoMedioTerceiroAno from '@/components/segmento-de-conteudo/banco_livros/ensinoMedio/terceiro-ano.vue'

/* OUTRAS PÁGINAS */
import about from '@/components/pages/about.vue'
import erro404 from '@/components/pages/Error404.vue'
import erro503 from '@/components/pages/Error503.vue'
import sejaEscolaParceira from '@/components/pages/secoes/formEscolaParceira.vue'
import colecoesInfantil from '@/components/pages/openedInfantil.vue'
import colecaoEfi from '@/components/pages/openedEfi.vue'
import colecaoEfii from '@/components/pages/openedEfii.vue'
import ensinoMedio from '@/components/pages/openedEnsinoMedio.vue'
import preVestibular from '@/components/pages/openedPreVestibular.vue'
import openEnem from '@/components/pages/openedEnem.vue'
import openAssessoria from '@/components/pages/openedAssessoria.vue'
import openCarreira from '@/components/pages/openedCarreiras.vue'
import contatoSimples from '@/components/pages/OpenedContato.vue'
 
import registerResp from '@/views/auth/registerResp.vue'
import registerColoborador from '@/views/auth/registerDocente.vue'
import underMaitence from '@/components/pages/Maintenance.vue'
import register from '@/views/auth/register.vue'
import thanks from '@/components/GlobalComponents/thankYouComponent.vue'
import passwordUpdate from '@/views/auth/pass_recovery_update'

import e24h from '@/components/pages/clientes/e_24h.vue'

 
import e24hRegisterUser from '@/components/pages/solucoes/24h/index.vue'

import habilitaUserSistemaComE24h from '@/components/pages/solucoes/24h/habilitaUserSistemaE24h.vue'

import carreiraSimple from '@/components/pages/secoes/CarreiraSimple.vue'

import renderContent from '@/components/segmento-de-conteudo/RenderContent/RenderContent.vue'
 
import assoc from '@/views/users/associationUserClasse.vue'
 

const routes = [
  { path: '/maintenance', component: maintenance, name: 'maintenance', meta: { layout: 'landing' } },

  //retorno generico de form
  { path: '/obrigado/:nome', name: 'thanks-escola-parceira', component: thanks, meta: { layout: 'landing' } },

  { path: '*', component: erro404, name: 'erro404', meta: { layout: 'landing' } },
  { path: '/nao-autorizado', component: erro503, name: 'erroServidor', meta: { layout: 'landing' } },
  {
    path: '/conteudo-exclusivo',
    name: 'home',
    component: conteudoExclusivo,
    meta: { section_name: 'area_restrit', title: 'Conteúdo Exclusivo' },
  },
  { path: '/assoc', component: assoc, name: 'assoc', meta: { layout: 'landing' } },

  //dashboard
  {
    path: '',
    name: '',
    component: defaultLanding,
    meta: { layout: 'landing' },
    children: [
      { path: '/', name: 'landing', component: landing, meta: { layout: 'landing' } },
      {
        path: 'seja-uma-escola-parceira',
        name: 'escolaParceira',
        component: sejaEscolaParceira,
        meta: { layout: 'landing', section_name: 'area_opened', title: 'Escola Parceira' },
      },

      {
        path: 'about',
        name: 'about',
        component: about,
        meta: { layout: 'landing', section_name: 'area_opened', title: 'Sobre Nós' },
      },
      {
        path: 'assesssoria',
        name: 'openedAssessoria',
        component: openAssessoria,
        meta: { layout: 'landing', section_name: 'area_opened', title: 'Assessoria' },
      },
      {
        path: 'carreiras',
        name: 'openCarreiras',
        component: openCarreira,
        meta: { layout: 'landing', section_name: 'area_opened', title: 'Carreiras CPV' },
        beforeEnter: () => {
          location.href = 'https://cpv.com.br/carreiras'
        },
      },
      {
        path: 'contato',
        name: 'contatoSimples',
        component: contatoSimples,
        meta: { layout: 'landing', section_name: 'area_opened', title: 'Contato' },
        beforeEnter: () => {
          location.href = 'https://cpv.com.br/contato'
        },
      },
      {
        path: 'trabalhe-conosco',
        name: 'carreiraSimples',
        component: carreiraSimple,
        meta: { layout: 'landing', section_name: 'area_opened', title: 'Trabalhe Conosco' },
      },
    ],
  },
  {
    //area aberta
    path: '/colecoes',
    name: '',
    component: defaultLanding,
    meta: { layout: 'landing' },
    children: [
      {
        path: '/',
        name: 'landingPage',
        component: landing,
        meta: { layout: 'landing', section_name: 'area_opened', title: 'Home' },
      },
      {
        path: 'infantil',
        name: 'colecaoInfantil',
        component: colecoesInfantil,
        meta: { layout: 'landing', grants: ['teste'], section_name: 'area_opened', title: 'Educação Infantil' },
      },
      {
        path: 'ensino-fundamental-i',
        name: 'colecaoEfi',
        component: colecaoEfi,
        meta: { layout: 'landing', section_name: 'area_opened', title: 'Ensino Fundamental I' },
      },
      {
        path: 'ensino-fundamental-ii',
        name: 'colecaoEfii',
        component: colecaoEfii,
        meta: { layout: 'landing', section_name: 'area_opened', title: 'Ensino Fundamental II' },
      },
      {
        path: 'ensino-medio',
        name: 'colecaoensinoMedio',
        component: ensinoMedio,
        meta: { layout: 'landing', section_name: 'area_opened', title: 'Ensino Médio' },
      },
      {
        path: 'pre-vestibular',
        name: 'colecaoPreVestibular',
        component: preVestibular,
        meta: { layout: 'landing', section_name: 'area_opened', title: 'Pré-Vestibular' },
      },
      {
        path: 'enem',
        name: 'colecaoEnem',
        component: openEnem,
        meta: { layout: 'landing', section_name: 'area_opened', title: 'ENEM' },
      },
      {
        path: 'professional_curriculum/:nome',
        name: 'professionalCurriculum',
        component: thanks,
        meta: { layout: 'landing' },
      },
      {
        path: 'contato',
        name: 'contato',
        component: contatoSimples,
        meta: { layout: 'landing', section_name: 'area_opened', title: 'Contato' },
      },
    ],
  },
  {
    //area fechada
    path: '/segmento-de-conteudo',
    name: 'segmento-de-conteudo',
    component: exclusivo,
    meta: { section_name: 'area_restrit' },
    children: [
      { path: 'maintenance', component: maintenance, name: 'maintenance', meta: { layout: 'landing' } },

      // infantil
      {
        //mareial apenas para criar a url limpa. paramsForUrl, vai para o backpara formar o link
        path: 'r',
        name: 'render-conteudo-exclusivo',
        component: renderContent,
        props: (route) => ({
          paramsForUrl: route.params.paramsForUrl,
          nomeApostila: route.params.nomeApostila,
          material: route.query.material,
        }),
      },

      {
        path: 'infantil-dashboard',
        name: 'childrenInfantil',
        component: dashInfantil,
        meta: { section_name: 'area_restrit', section_childname: 'area_infantil', title: 'Educação Infantil' },
      },
      {
        path: 'infantil-caderno-digital',
        name: 'infantil-caderno-digital',
        component: cadernoDigitalInfantil,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_infantil',
          section_thirdname: 'area_colecao',
          title: 'COLEÇÃO CPV',
        },
      },

      {
        path: 'musicas',
        name: 'musicasVideos',
        component: musicasVideos,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_infantil',
          section_thirdname: 'area_musica',
          title: 'Músicas & Vídeos',
        },
      },
      {
        path: 'flashcards',
        name: 'dashFlash',
        component: flashCards,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_infantil',
          section_thirdname: 'area_colecaoBooksInfantil',
          title: 'Flashcards',
        },
      },
      {
        path: 'infantil-2-maternal-i',
        name: 'dashInfantilMaternalI',
        component: InfantilII,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_infantil',
          section_thirdname: 'area_colecaoBooksInfantil',
          title: 'Infantil 2 (Maternal I)',
        },
      },
      {
        path: 'infantil-3-maternal-ii',
        name: 'dashInfantilMaternalII',
        component: InfantilIII,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_infantil',
          section_thirdname: 'area_colecaoBooksInfantil',
          title: 'Infantil 3 (Maternal II)',
        },
      },
      {
        path: 'infantil-4-jardim-i',
        name: 'dashInfantilJardimI',
        component: InfantilIV,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_infantil',
          section_thirdname: 'area_colecaoBooksInfantil',
          title: 'Infantil 4 (Jardim I)',
        },
      },
      {
        path: 'infantil-5-jardim-ii',
        name: 'dashInfantilJardimII',
        component: InfantilV,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_infantil',
          section_thirdname: 'area_colecaoBooksInfantil',
          title: 'Infantil 5 (Jardim II)',
        },
      },
      {
        path: 'programacao',
        name: 'dashProgramacao',
        component: Programacao,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_infantil',
          section_thirdname: 'area_programacao',
          title: 'Programação',
        },
      },
      {
        path: 'manual',
        name: 'dashManual',
        component: Manual,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_infantil',
          section_thirdname: 'area_manual',
          title: 'Manual',
        },
      },
      {
        path: 'maternal-i',
        name: 'dashMaternalI',
        component: MaternalI,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_infantil',
          section_thirdname: 'area_bookManual',
          title: 'Infantil 2 - (Maternal I)',
        },
      },
      {
        path: 'maternal-ii',
        name: 'dashMaternalII',
        component: MaternalII,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_infantil',
          section_thirdname: 'area_bookManual',
          title: 'Infantil 3 (Maternal II) - Manual',
        },
      },
      {
        path: 'jardim-i',
        name: 'dashJardimI',
        component: JardimI,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_infantil',
          section_thirdname: 'area_bookManual',
          title: 'Infantil 4 (Jardim I) - Manual',
        },
      },
      {
        path: 'jardim-ii',
        name: 'dashJardimII',
        component: JardimII,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_infantil',
          section_thirdname: 'area_bookManual',
          title: 'Infantil 5 (Jardim II) - Manual',
        },
      },
      {
        path: 'maternal-i-musicas',
        name: 'dashMusicaMaternalI',
        component: MusicaMaternalI,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_infantil',
          section_thirdname: 'area_bookMusicas',
          title: 'Infantil 2 (Maternal I) - Músicas',
        },
      },
      {
        path: 'maternal-ii-musicas',
        name: 'dashMusicaMaternalII',
        component: MusicaMaternalII,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_infantil',
          section_thirdname: 'area_bookMusicas',
          title: 'Infantil 3 (Maternal II) - Músicas',
        },
      },
      {
        path: 'jardim-i-musicas',
        name: 'dashMusicaJardimI',
        component: MusicaJardimI,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_infantil',
          section_thirdname: 'area_bookMusicas',
          title: 'Infantil 4 (Jardim I) - Músicas',
        },
      },
      {
        path: 'jardim-ii-musicas',
        name: 'dashMusicaJardimII',
        component: MusicaJardimII,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_infantil',
          section_thirdname: 'area_bookMusicas',
          title: 'Infantil 5 (Jardim II) - Músicas',
        },
      },

      //Fund1
      {
        path: 'fundamental-1-dashboard',
        name: 'dashFund1',
        component: dashFund1,
        meta: { section_name: 'area_restrit', section_childname: 'area_fundI', title: 'Ensino Fundamental I' },
      },
      {
        path: 'fundamental-1-caderno-digital',
        name: 'cadernoDigitalFund1',
        component: CadernoDigital,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundI',
          section_thirdname: 'area_colecao',
          title: 'Coleção CPV',
        },
        children: [],
      },
      /* 1º ANO */
      {
        path: 'fundamental-1-primeiro-ano',
        name: 'cadernoDigitalFund1PrimeiroAno',
        component: primeiroAno,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundI',
          section_thirdname: 'area_colecaoBooksFundI',
          title: 'Fundamental I - 1º Ano',
        },
      },
      /* 2º ANO */
      {
        path: 'fundamental-1-segundo-ano',
        name: 'cadernoDigitalFund1SegundoAno',
        component: SegundoAno,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundI',
          section_thirdname: 'area_colecaoBooksFundI',
          title: 'Fundamental I - 2º Ano',
        },
      },
      /* 3º ANO */
      {
        path: 'fundamental-1-terceiro-ano',
        name: 'cadernoDigitalFund1TerceiroAno',
        component: terceiroAno,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundI',
          section_thirdname: 'area_colecaoBooksFundI',
          title: 'Fundamental I - 3º Ano',
        },
      },
      /* 4º ANO */
      {
        path: 'fundamental-1-quarto-ano',
        name: 'cadernoDigitalFund1QuartoAno',
        component: quartoAno,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundI',
          section_thirdname: 'area_colecaoBooksFundI',
          title: 'Fundamental I - 4º Ano',
        },
      },
      /* 5º ANO */
      {
        path: 'fundamental-1-quinto-ano',
        name: 'cadernoDigitalFund1QuintoAno',
        component: quintoAno,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundI',
          section_thirdname: 'area_colecaoBooksFundI',
          title: 'Fundamental I - 5º Ano',
        },
      },
      /* MATERIAL COMPLEMENTAR */
      {
        path: 'fundamental-1-material-complementar',
        name: 'cadernoDigitalFund1MaterialComplementar',
        component: materialComplementarFund1,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundI',
          section_thirdname: 'area_colecaoBooksFundI',
          title: 'Fundamental I - Materiais Complementares',
        },
      },
      /* SIMULADOS */
      {
        path: 'provas-simulados',
        name: 'simuladosFund1',
        component: simuladosFund1,
        section_name: 'area_restrit',
        section_childname: 'area_fundI',
        title: 'Caderno Digital',
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundI',
          section_thirdname: 'area_simuladosFundI',
          title: 'Simulados',
        },
      },
      /* SIMULADOS - 2º ANO */
      {
        path: 'simulados-ensino-fundamental-2-ano',
        name: 'simuladosSegundoAno',
        component: simuladosFund1_2Ano,
        section_name: 'area_restrit',
        section_childname: 'area_fundI',
        title: 'Simulado 2º Ano',
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundI',
          section_thirdname: 'area_booksSimuladosFundI',
          title: 'Simulados - 2º Ano',
        },
      },
      /* SIMULADOS - 3º ANO */
      {
        path: 'simulados-ensino-fundamental-3-ano',
        name: 'simuladosTerceiroAno',
        component: simuladosFund1_3Ano,
        section_name: 'area_restrit',
        section_childname: 'area_fundI',
        title: 'Simulado 3º Ano',
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundI',
          section_thirdname: 'area_booksSimuladosFundI',
          title: 'Simulados - 3º Ano',
        },
      },
      /* SIMULADOS - 4º ANO */
      {
        path: 'simulados-ensino-fundamental-4-ano',
        name: 'simuladosQuartoAno',
        component: simuladosFund1_4Ano,
        section_name: 'area_restrit',
        section_childname: 'area_fundI',
        title: 'Simulado 4º Ano',
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundI',
          section_thirdname: 'area_booksSimuladosFundI',
          title: 'Simulados - 4º Ano',
        },
      },
      /* SIMULADOS - 5º ANO */
      {
        path: 'simulados-ensino-fundamental-5-ano',
        name: 'simuladosQuintoAno',
        component: simuladosFund1_5Ano,
        section_name: 'area_restrit',
        section_childname: 'area_fundI',
        title: 'Simulado 5º Ano',
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundI',
          section_thirdname: 'area_booksSimuladosFundI',
          title: 'Simulados - 5º Ano',
        },
      },
      /* PROGRAMAÇÃO */
      {
        path: 'programacao-ensino-fundamental-i',
        name: 'programaçãoFundI',
        component: programacaoFundI,
        section_name: 'area_restrit',
        section_childname: 'area_fundI',
        title: 'Programação',
        meta: { section_name: 'area_restrit', section_childname: 'area_fundI', title: 'Programação' },
      },

      /* MANUAL */
      {
        path: 'manual-ensino-fundamental-i',
        name: 'manualFundI',
        component: manualFundI,
        section_name: 'area_restrit',
        section_childname: 'area_fundI',
        title: 'Manual - Fundamental I',
        meta: { section_name: 'area_restrit', section_childname: 'area_fundI', title: 'MANUAL' },
      },
      /* MANUAL - 1º ANO */
      {
        path: 'manual-1o-ano',
        name: 'manualFundIPrimeiroAno',
        component: manual1Ano,
        section_name: 'area_restrit',
        section_childname: 'area_fundI',
        title: 'Manual - Fundamental I',
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundI',
          section_thirdname: 'area_booksManualFundI',
          title: '1º ANO - MANUAL',
        },
      },
      /* MANUAL - 2º ANO */
      {
        path: 'manual-2o-ano',
        name: 'manualFundISegundoAno',
        component: manual2Ano,
        section_name: 'area_restrit',
        section_childname: 'area_fundI',
        title: 'Manual - Fundamental I',
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundI',
          section_thirdname: 'area_booksManualFundI',
          title: '2º ANO - MANUAL',
        },
      },
      /* MANUAL - 3º ANO */
      {
        path: 'manual-3o-ano',
        name: 'manualFundITerceiroAno',
        component: manual3Ano,
        section_name: 'area_restrit',
        section_childname: 'area_fundI',
        title: 'Manual - Fundamental I',
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundI',
          section_thirdname: 'area_booksManualFundI',
          title: '3º ANO - MANUAL',
        },
      },
      /* MANUAL - 4º ANO */
      {
        path: 'manual-4o-ano',
        name: 'manualFundIQuartoAno',
        component: manual4Ano,
        section_name: 'area_restrit',
        section_childname: 'area_fundI',
        title: 'Manual - Fundamental I',
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundI',
          section_thirdname: 'area_booksManualFundI',
          title: '4º ANO - MANUAL',
        },
      },
      /* MANUAL - 5º ANO */
      {
        path: 'manual-5o-ano',
        name: 'manualFundIQuintoAno',
        component: manual5Ano,
        section_name: 'area_restrit',
        section_childname: 'area_fundI',
        title: 'Manual - Fundamental I',
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundI',
          section_thirdname: 'area_booksManualFundI',
          title: '5º ANO - MANUAL',
        },
      },
      /* MÚSICA & VÍDEO */
      {
        path: 'ensino-fund1-musicas',
        name: 'musicaFundI',
        component: musicaFundI,
        meta: { section_name: 'area_restrit', section_childname: 'area_fundI', title: 'Música & Vídeo' },
      },
      {
        path: 'musica-1o-ano',
        name: 'musicaFundIPrimeiroAno',
        component: musica1oAno,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundI',
          section_thirdname: 'area_booksMusicaFundI',
          title: '1º Ano',
        },
      },
      {
        path: 'musica-2o-ano',
        name: 'musicaFundISegundoAno',
        component: musica2oAno,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundI',
          section_thirdname: 'area_booksMusicaFundI',
          title: '2º Ano',
        },
      },
      {
        path: 'musica-3o-ano',
        name: 'musicaFundITerceiroAno',
        component: musica3oAno,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundI',
          section_thirdname: 'area_booksMusicaFundI',
          title: '3º Ano',
        },
      },
      {
        path: 'musica-4o-ano',
        name: 'musicaFundIQuartoAno',
        component: musica4oAno,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundI',
          section_thirdname: 'area_booksMusicaFundI',
          title: '4º Ano',
        },
      },
      {
        path: 'musica-5o-ano',
        name: 'musicaFundIQuintoAno',
        component: musica5oAno,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundI',
          section_thirdname: 'area_booksMusicaFundI',
          title: '5º Ano',
        },
      },

      //  FUNDAMENTAL 2
      {
        path: 'fundamental-2-dashboard',
        name: 'dashFund2',
        component: dashFund2,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundII',
          title: 'ENSINO FUNDAMENTAL II',
        },
      },

      // FUNDAMENTAL II - COLEÇÃO CPV
      {
        path: 'fundamental-2-colecao-cpv',
        name: 'colecaoFund2',
        component: fundIIColecao,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundII',

          title: 'COLEÇÃO CPV',
        },
      },
      {
        path: 'fundamental-2-sexto-ano',
        name: 'ColecaoSextoAnoFundII',
        component: fundIIColecaoSexto,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundII',
          section_thirdname: 'area_booksColecaoFundII',
          title: '6º Ano',
        },
      },
      {
        path: 'fundamental-2-setimo-ano',
        name: 'ColecaoSetimoAnoFundII',
        component: fundIIColecaoSetimo,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundII',
          section_thirdname: 'area_booksColecaoFundII',
          title: '7º Ano',
        },
      },
      {
        path: 'fundamental-2-oitavo-ano',
        name: 'ColecaoOitavoAnoFundII',
        component: fundIIColecaoOitavo,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundII',
          section_thirdname: 'area_booksColecaoFundII',
          title: '8º Ano',
        },
      },
      {
        path: 'fundamental-2-nono-ano',
        name: 'ColecaoNonoAnoFundII',
        component: fundIIColecaoNono,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundII',
          section_thirdname: 'area_booksColecaoFundII',
          title: '9º Ano',
        },
      },
      {
        path: 'fundamental-2-material-espanhol',
        name: 'ColecaoEspanholFundII',
        component: fundIIColecaoEspanhol,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundII',
          section_thirdname: 'area_booksColecaoFundII',
          title: 'Material Complementar - Espanhol',
        },
      },
      {
        path: 'fundamental-2-material-ingles',
        name: 'ColecaoInglesFundII',
        component: fundIIColecaoIngles,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundII',
          section_thirdname: 'area_booksColecaoFundII',
          title: 'Material Complementar - Inglês',
        },
      },

      // FUNDAMENTAL II - SIMULADOS
      {
        path: 'fundamental-2-simulados',
        name: 'simuladosFund2',
        component: fundIISimulados,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundII',
          title: 'Simulados',
        },
      },
      {
        path: 'fundamental-2-simulados-sexto-ano',
        name: 'SimuladosSextoAnoFundII',
        component: fundIISimuladosSexto,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundII',
          section_thirdname: 'area_booksSimuladosFundII',
          title: '6º Ano',
        },
      },
      {
        path: 'fundamental-2-simulados-setimo-ano',
        name: 'SimuladosSetimoAnoFundII',
        component: fundIISimuladosSetimo,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundII',
          section_thirdname: 'area_booksSimuladosFundII',
          title: '7º Ano',
        },
      },
      {
        path: 'fundamental-2-simulados-oitavo-ano',
        name: 'SimuladosOitavoAnoFundII',
        component: fundIISimuladosOitavo,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundII',
          section_thirdname: 'area_booksSimuladosFundII',
          title: '8º Ano',
        },
      },
      {
        path: 'fundamental-2-simulados-nono-ano',
        name: 'SimuladosNonoAnoFundII',
        component: fundIISimuladosNono,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundII',
          section_thirdname: 'area_booksSimuladosFundII',
          title: '9º Ano',
        },
      },

      // FUNDAMENTAL II - PROGRAMAÇÃO
      {
        path: 'fundamntal-2-programacao',
        name: 'programacaoFund2',
        component: fundIIProgramacao,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundII',
          title: 'Programação',
        },
      },

      // FUNDAMENTAL II - MANUAL
      {
        path: 'fundamental-2-manual',
        name: 'manualFund2',
        component: fundIIManual,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundII',
          title: 'Manual',
        },
      },
      {
        path: 'fundamental-2-manual-sexto-ano',
        name: 'manualSextoAnoFundII',
        component: fundIIManualSexto,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundII',
          section_thirdname: 'area_booksManualFundII',
          title: '6º Ano',
        },
      },
      {
        path: 'fundamental-2-manual-setimo-ano',
        name: 'manualSetimoAno',
        component: fundIIManualSetimo,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundII',
          section_thirdname: 'area_booksManualFundII',
          title: '7º Ano',
        },
      },
      {
        path: 'fundamental-2-manual-oitavo-ano',
        name: 'manualOitavoAno',
        component: fundIIManualOitavo,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundII',
          section_thirdname: 'area_booksManualFundII',
          title: '8º Ano',
        },
      },
      {
        path: 'fundamental-2-manual-nono-ano',
        name: 'manualNonoAno',
        component: fundIIManualNono,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundII',
          section_thirdname: 'area_booksManualFundII',
          title: '9º Ano',
        },
      },

      // FUNDAMENTAL II - Projeto Interdisciplinar

      {
        path: 'fundamental-2-projetos-interdisciplinares',
        name: 'cadernoDigitalFound2',
        component: fundIIProjetoInterdisciplinar,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_fundII',
          title: 'Projetos Interdisciplinares',
        },
      },

      //  Ensino Médio
      {
        path: 'ensino-medio-dashboard',
        name: 'dashEnsinoMedio',
        component: dashEnsinoMedio,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          title: 'ENSINO MÉDIO',
        },
      },

      /* ENSINO MÉDIO - COLEÇÃO CPV */
      {
        path: 'ensino-medio-colecao-cpv',
        name: 'cadernoDigitalEnsinoMedio',
        component: cadernoDigitalEnsinoMedio,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          title: 'Caderno Digital',
        },
      },
      {
        path: 'ensino-medio-colecao-primeiro-ano',
        name: 'colecaoPrimeiroAno',
        component: primeiroAnoEM,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__colecaoEM',
          title: '1º Ano',
        },
      },
      {
        path: 'ensino-medio-colecao-segundo-ano',
        name: 'colecaoSegundoAno',
        component: segundoAnoEM,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__colecaoEM',
          title: '2º Ano',
        },
      },
      {
        path: 'ensino-medio-colecao-terceiro-ano',
        name: 'colecaoTerceiroAno',
        component: terceiroAnoEM,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__colecaoEM',
          title: '3º Ano',
        },
      },
      {
        path: 'ensino-medio-colecao-material-complementar',
        name: 'colecaoMaterialComplementar',
        component: materialComplementarEM,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__colecaoEM',
          title: 'Material Complementar',
        },
      },
      /* ENSINO MÉDIO - PROGRAMAÇÃO */
      {
        path: 'ensino-medio-programacao',
        name: 'programacaoEnsinoMedio',
        component: programacaoEnsinoMedio,
        meta: { section_name: 'area_restrit', section_childname: 'area_medio', title: 'Programação' },
      },
      /* ENSINO MÉDIO - MANUAL */
      {
        path: 'ensino-medio-manual',
        name: 'manualEnsinoMedio',
        component: manualEnsinoMedio,
        meta: { section_name: 'area_restrit', section_childname: 'area_medio', title: 'Manual' },
      },
      {
        path: 'ensino-medio-manual-primeiro-ano',
        name: 'manualEnsinoMedioPrimeiroAno',
        component: primeiroAnoManualEM,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__manualEM',
          title: '1º Ano',
        },
      },
      {
        path: 'ensino-medio-manual-segundo-ano',
        name: 'manualEnsinoMedioSegundoAno',
        component: segundoAnoManualEM,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__manualEM',
          title: '2º Ano',
        },
      },
      {
        path: 'ensino-medio-manual-terceiro-ano',
        name: 'manualEnsinoMedioTerceiroAno',
        component: terceiroAnoManualEM,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__manualEM',
          title: '3º Ano',
        },
      },

      /* ENSINO MÉDIO - AULAS DIGITAIS */
      {
        path: 'ensino-medio-aula-digital',
        name: 'aulasDigitaisEnsinoMedio',
        component: aulasDigitaisEnsinoMedio,
        meta: { section_name: 'area_restrit', section_childname: 'area_medio', title: 'Aulas Digitais' },
      },
      {
        path: 'ensino-medio-aula-digital-quimica',
        name: 'aulasDigitaisEMQuimica',
        component: aulaDigitalQuimicaEM,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__aulasDigitaisEM',
          title: 'Química',
        },
      },
      {
        path: 'ensino-medio-aula-digital-biologia',
        name: 'aulasDigitaisEMBiologia',
        component: aulaDigitalBiologiaEM,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__aulasDigitaisEM',
          title: 'Biologia',
        },
      },
      {
        path: 'ensino-medio-aula-digital-fisica',
        name: 'aulasDigitaisEMfisica',
        component: aulaDigitalfisicaEM,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__aulasDigitaisEM',
          title: 'Física',
        },
      },
      {
        path: 'ensino-medio-aula-digital-geografia',
        name: 'aulasDigitaisEMgeografia',
        component: aulaDigitalgeografiaEM,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__aulasDigitaisEM',
          title: 'Geografia',
        },
      },
      {
        path: 'ensino-medio-aula-digital-historia',
        name: 'aulasDigitaisEMhistoria',
        component: aulaDigitalhistoriaEM,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__aulasDigitaisEM',
          title: 'História',
        },
      },
      {
        path: 'ensino-medio-aula-digital-lp',
        name: 'aulasDigitaisEMLp',
        component: aulaDigitalLpEM,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__aulasDigitaisEM',
          title: 'Língua Portuguesa',
        },
      },
      {
        path: 'ensino-medio-aula-digital-literatura',
        name: 'aulasDigitaisEMliteratura',
        component: aulaDigitalLiteraturaEM,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__aulasDigitaisEM',
          title: 'Literatura',
        },
      },
      {
        path: 'ensino-medio-aula-digital-matematica',
        name: 'aulasDigitaisEMmatematica',
        component: aulaDigitalmatematicaEM,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__aulasDigitaisEM',
          title: 'Aulas Digitais',
        },
      },
      {
        path: 'ensino-medio-aula-digital-redacao',
        name: 'ulasDiEmgitaisEMRedacao',
        component: aulaDigitalRedacaoEM,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__aulasDigitaisEM',
          title: 'Redação',
        },
      },

      /* ENSINO MÉDIO - RESOLUÇÕES */
      {
        path: 'ensino-medio-resolucoes',
        name: 'dashResolucoesEnsinoMedio',
        component: resolucoesEnsinoMedio,
        meta: { section_name: 'area_restrit', section_childname: 'area_medio', title: 'Resoluções' },
      },
      /* ENSINO MÉDIO - RESOLUÇÕES DE MATEMÁTICA */
      {
        path: 'ensino-medio-resolucoes-matematica',
        name: 'resolucoesEnsinoMedioMat',
        component: resolucoesMTEnsinoMedio,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__resolucoesEM',
          title: 'Resoluções - Matemática',
        },
      },
      {
        path: 'ensino-medio-resolucoes-caderno-1-matematica',
        name: 'resolucoesEnsinoMedioMatematicaCaderno1',
        component: caderno1ResolucoesMatematica,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__resolucoesEM',
          section_resolution: 'area_cadernoResolucoesMatematicaEM',
          title: 'Matemática - Caderno 1',
        },
      },
      {
        path: 'ensino-medio-resolucoes-caderno-2-matematica',
        name: 'resolucoesEnsinoMedioMatematicaCaderno2',
        component: caderno2ResolucoesMatematica,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__resolucoesEM',
          section_resolution: 'area_cadernoResolucoesMatematicaEM',
          title: 'Matemática - Caderno 2',
        },
      },
      {
        path: 'ensino-medio-resolucoes-caderno-3-matematica',
        name: 'resolucoesEnsinoMedioMatematicaCaderno3',
        component: caderno3ResolucoesMatematica,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__resolucoesEM',
          section_resolution: 'area_cadernoResolucoesMatematicaEM',
          title: 'Matemática - Caderno 3',
        },
      },
      {
        path: 'ensino-medio-resolucoes-caderno-4-matematica',
        name: 'resolucoesEnsinoMedioMatematicaCaderno4',
        component: caderno4ResolucoesMatematica,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__resolucoesEM',
          section_resolution: 'area_cadernoResolucoesMatematicaEM',
          title: 'Matemática - Caderno 4',
        },
      },
      {
        path: 'ensino-medio-resolucoes-caderno-5-matematica',
        name: 'resolucoesEnsinoMedioMatematicaCaderno5',
        component: caderno5ResolucoesMatematica,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__resolucoesEM',
          section_resolution: 'area_cadernoResolucoesMatematicaEM',
          title: 'Matemática - Caderno 5',
        },
      },
      {
        path: 'ensino-medio-resolucoes-caderno-6-matematica',
        name: 'resolucoesEnsinoMedioMatematicaCaderno6',
        component: caderno6ResolucoesMatematica,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__resolucoesEM',
          section_resolution: 'area_cadernoResolucoesMatematicaEM',
          title: 'Matemática - Caderno 6',
        },
      },
      {
        path: 'ensino-medio-resolucoes-caderno-7-matematica',
        name: 'resolucoesEnsinoMedioMatematicaCaderno7',
        component: caderno7ResolucoesMatematica,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__resolucoesEM',
          section_resolution: 'area_cadernoResolucoesMatematicaEM',
          title: 'Matemática - Caderno 7',
        },
      },
      {
        path: 'ensino-medio-resolucoes-caderno-8-matematica',
        name: 'resolucoesEnsinoMedioMatematicaCaderno8',
        component: caderno8ResolucoesMatematica,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__resolucoesEM',
          section_resolution: 'area_cadernoResolucoesMatematicaEM',
          title: 'Matemática - Caderno 8',
        },
      },
      {
        path: 'ensino-medio-resolucoes-caderno-9-matematica',
        name: 'resolucoesEnsinoMedioMatematicaCaderno9',
        component: caderno9ResolucoesMatematica,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__resolucoesEM',
          section_resolution: 'area_cadernoResolucoesMatematicaEM',
          title: 'Matemática - Caderno 9',
        },
      },
      {
        path: 'ensino-medio-resolucoes-caderno-10-matematica',
        name: 'resolucoesEnsinoMedioMatematicaCaderno10',
        component: caderno10ResolucoesMatematica,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__resolucoesEM',
          section_resolution: 'area_cadernoResolucoesMatematicaEM',
          title: 'Matemática - Caderno 10',
        },
      },

      {
        path: 'ensino-medio-resolucoes-fisica',
        name: 'resolucoesEnsinoMedioFisica',
        component: resolucoesFSEnsinoMedio,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__resolucoesEM',
          title: 'Resoluções - Física',
        },
      },

      {
        path: 'ensino-medio-resolucoes-quimica',
        name: 'resolucoesEnsinoMedioQuimica',
        component: resolucoesQMEnsinoMedio,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__resolucoesEM',
          title: 'Resoluções - Química',
        },
      },
      {
        path: 'ensino-medio-resolucoes-caderno-1-quimica',
        name: 'resolucoesEnsinoMedioQuimicaCaderno1',
        component: caderno1ResolucoesQuimica,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__resolucoesEM',
          section_resolution: 'area_cadernoResolucoesQuimicaEM',
          title: 'Química - Caderno 1',
        },
      },
      {
        path: 'ensino-medio-resolucoes-caderno-2-quimica',
        name: 'resolucoesEnsinoMedioQuimicaCaderno2',
        component: caderno2ResolucoesQuimica,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__resolucoesEM',
          section_resolution: 'area_cadernoResolucoesQuimicaEM',
          title: 'Química - Caderno 2',
        },
      },
      {
        path: 'ensino-medio-resolucoes-caderno-3-quimica',
        name: 'resolucoesEnsinoMedioQuimicaCaderno3',
        component: caderno3ResolucoesQuimica,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__resolucoesEM',
          section_resolution: 'area_cadernoResolucoesQuimicaEM',
          title: 'Química - Caderno 3',
        },
      },
      {
        path: 'ensino-medio-resolucoes-caderno-4-quimica',
        name: 'resolucoesEnsinoMedioQuimicaCaderno4',
        component: caderno4ResolucoesQuimica,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__resolucoesEM',
          section_resolution: 'area_cadernoResolucoesQuimicaEM',
          title: 'Química - Caderno 4',
        },
      },
      {
        path: 'ensino-medio-resolucoes-caderno-5-quimica',
        name: 'resolucoesEnsinoMedioQuimicaCaderno5',
        component: caderno5ResolucoesQuimica,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__resolucoesEM',
          section_resolution: 'area_cadernoResolucoesQuimicaEM',
          title: 'Química - Caderno 5',
        },
      },
      {
        path: 'ensino-medio-resolucoes-caderno-6-quimica',
        name: 'resolucoesEnsinoMedioQuimicaCaderno6',
        component: caderno6ResolucoesQuimica,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__resolucoesEM',
          section_resolution: 'area_cadernoResolucoesQuimicaEM',
          title: 'Química - Caderno 6',
        },
      },
      {
        path: 'ensino-medio-resolucoes-caderno-7-quimica',
        name: 'resolucoesEnsinoMedioQuimicaCaderno7',
        component: caderno7ResolucoesQuimica,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__resolucoesEM',
          section_resolution: 'area_cadernoResolucoesQuimicaEM',
          title: 'Química - Caderno 7',
        },
      },
      {
        path: 'ensino-medio-resolucoes-caderno-8-quimica',
        name: 'resolucoesEnsinoMedioQuimicaCaderno8',
        component: caderno8ResolucoesQuimica,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__resolucoesEM',
          section_resolution: 'area_cadernoResolucoesQuimicaEM',
          title: 'Química - Caderno 8',
        },
      },
      {
        path: 'ensino-medio-resolucoes-caderno-9-quimica',
        name: 'resolucoesEnsinoMedioQuimicaCaderno9',
        component: caderno9ResolucoesQuimica,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__resolucoesEM',
          section_resolution: 'area_cadernoResolucoesQuimicaEM',
          title: 'Química - Caderno 9',
        },
      },
      {
        path: 'ensino-medio-resolucoes-caderno-10-quimica',
        name: 'resolucoesEnsinoMedioQuimicaCaderno10',
        component: caderno10ResolucoesQuimica,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__resolucoesEM',
          section_resolution: 'area_cadernoResolucoesQuimicaEM',
          title: 'Química - Caderno 10',
        },
      },

      {
        path: 'ensino-medio-aula-digital-prg-base',
        name: 'aulasDigitaisEMProgamacaoBase',
        component: aulaDigitalPrgBaseEM,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__aulasDigitaisEM',
          title: 'Programação Base',
        },
      },

      /* Ensino Médio - Projetos Interdisciplinares */
      {
        path: 'ensino-medio-projetos-interdisciplinares',
        name: 'projetosInterdisciplinar',
        component: ProjetosInterdisciplinaresEM,
        meta: { section_name: 'area_restrit', section_childname: 'area_medio', title: 'Exercícios Regionais' },
      },

      // Ensino Médio - Exercícios Regionais
      {
        path: 'ensino-medio-exercicios-regionais',
        name: 'exerciciosRegionaisEnsinoMedio',
        component: exerciciosRegionaisEnsinoMedio,
        meta: { section_name: 'area_restrit', section_childname: 'area_medio', title: 'Exercícios Regionais' },
      },

      // Ensino Médio - Exercícios Regionais - Minas Gerais
      {
        path: 'ensino-medio-exercicios-regionais-minas-gerais',
        name: 'exRegionaisMinasGerais',
        component: exerciciosRegionaisMinasGerais,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__booksExRegionais',
          title: 'Minas Gerais',
        },
      },

      // Ensino Médio - Exercícios Regionais - Rio de Janeiro
      {
        path: 'ensino-medio-exercicios-regionais-rio-de-janeiro',
        name: 'exRegionaisRioDeJaneiro',
        component: exerciciosRegionaisRioDeJaneiro,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__booksExRegionais',
          title: 'Rio de Janeiro',
        },
      },

      // Ensino Médio - Exercícios Regionais - Sul
      {
        path: 'ensino-medio-exercicios-regionais-sul',
        name: 'exRegionaisSul',
        component: exerciciosRegionaisSul,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_medio',
          section_thirdname: 'area__booksExRegionais',
          title: 'Sul',
        },
      },

      //pré-vestibular
      {
        path: 'pre-vestibular-dashboard',
        name: 'dashPreVestibular',
        component: dashPreVestibular,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_pre-vestibular',
          title: 'Pré-Vestibular',
        },
      },
      {
        path: 'pre-vestibular-programacao',
        name: 'programacaoPreVestibular',
        component: programacaoPreVestibular,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_pre-vestibular',
          title: 'Programação',
        },
      },
      {
        path: 'pre-vestibular-manual',
        name: 'manualPreVestibular',
        component: manualPreVestibular,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_pre-vestibular',
          title: 'Manual',
        },
      },
      {
        path: 'pre-vestibular-resolucoes',
        name: 'resolucoesPreVestibular',
        component: resolucoesPreVestibular,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_pre-vestibular',
          title: 'Resoluções',
        },
      },
      {
        path: 'pre-vestibular-resolucoes-matematica',
        name: 'resolucoesPreVestibularMatematica',
        component: resolucoesPreVestibularMatematica,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_pre-vestibular',
          section_thirdname: 'area__resolucoesPre-vestibular',
          title: 'Resoluções - Matemática',
        },
      },
      {
        path: 'pre-vestibular-resolucoes-caderno-2-matematica',
        name: 'resolucoesPreVestibularMatematicaCaderno2',
        component: resoPreVestibularCaderno2Matematica,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_pre-vestibular',
          section_thirdname: 'area__resolucoesPre-vestibular',
          section_resolution: 'area_cadernoResolucoesMatematicaPRE',
          title: 'Caderno 2',
        },
      },
      {
        path: 'pre-vestibular-resolucoes-caderno-3-matematica',
        name: 'resolucoesPreVestibularMatematicaCaderno3',
        component: resoPreVestibularCaderno3Matematica,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_pre-vestibular',
          section_thirdname: 'area__resolucoesPre-vestibular',
          section_resolution: 'area_cadernoResolucoesMatematicaPRE',
          title: 'Caderno 3',
        },
      },
      {
        path: 'pre-vestibular-resolucoes-caderno-4-matematica',
        name: 'resolucoesPreVestibularMatematicaCaderno4',
        component: resoPreVestibularCaderno4Matematica,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_pre-vestibular',
          section_thirdname: 'area__resolucoesPre-vestibular',
          section_resolution: 'area_cadernoResolucoesMatematicaPRE',
          title: 'Caderno 4',
        },
      },
      {
        path: 'pre-vestibular-resolucoes-caderno-5-matematica',
        name: 'resolucoesPreVestibularMatematicaCaderno5',
        component: resoPreVestibularCaderno5Matematica,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_pre-vestibular',
          section_thirdname: 'area__resolucoesPre-vestibular',
          section_resolution: 'area_cadernoResolucoesMatematicaPRE',
          title: 'Caderno 5',
        },
      },
      {
        path: 'pre-vestibular-resolucoes-caderno-6-matematica',
        name: 'resolucoesPreVestibularMatematicaCaderno6',
        component: resoPreVestibularCaderno6Matematica,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_pre-vestibular',
          section_thirdname: 'area__resolucoesPre-vestibular',
          section_resolution: 'area_cadernoResolucoesMatematicaPRE',
          title: 'Caderno 6',
        },
      },
      {
        path: 'pre-vestibular-resolucoes-caderno-7-matematica',
        name: 'resolucoesPreVestibularMatematicaCaderno7',
        component: resoPreVestibularCaderno7Matematica,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_pre-vestibular',
          section_thirdname: 'area__resolucoesPre-vestibular',
          section_resolution: 'area_cadernoResolucoesMatematicaPRE',
          title: 'Caderno 7',
        },
      },
      {
        path: 'pre-vestibular-resolucoes-caderno-8-matematica',
        name: 'resolucoesPreVestibularMatematicaCaderno8',
        component: resoPreVestibularCaderno8Matematica,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_pre-vestibular',
          section_thirdname: 'area__resolucoesPre-vestibular',
          section_resolution: 'area_cadernoResolucoesMatematicaPRE',
          title: 'Caderno 8',
        },
      },

      {
        path: 'pre-vestibular-exercicios-regionais',
        name: 'exerciciosRegionaisPreVestibular',
        component: exerciciosRegionaisPreVestibular,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_pre-vestibular',
          title: 'Exercícios Regionais',
        },
      },
      {
        path: 'pre-vestibular-exercicios-regionais-minas-gerais',
        name: 'cadernoMinasGeraisPre',
        component: cadernoExRegionaisMinasPre,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_pre-vestibular',
          section_thirdname: 'area_cadernoExRegionaisPre',
          title: 'Minas Gerais',
        },
      },
      {
        path: 'pre-vestibular-exercicios-regionais-rio-de-janeiro',
        name: 'cadernoRiodeJaneiroPre',
        component: cadernoExRegionaisRioPre,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_pre-vestibular',
          section_thirdname: 'area_cadernoExRegionaisPre',
          title: 'Rio de Janeiro',
        },
      },
      {
        path: 'pre-vestibular-exercicios-regionais-sul',
        name: 'cadernoSulPre',
        component: cadernoExRegionaisSulPre,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_pre-vestibular',
          section_thirdname: 'area_cadernoExRegionaisPre',
          title: 'Sul',
        },
      },

      //enem
      {
        path: 'enem-dashboard',
        name: 'dashEnem',
        component: dashEnem,
        meta: { section_name: 'area_restrit', title: 'ENEM' },
      },
      {
        path: 'enem-colecao-cpv',
        name: 'cadernoDigitalEnem',
        component: cadernoDigitalEnem,
        meta: { section_name: 'area_restrit', section_childname: 'area_enem', title: 'CADERNO DIGITAL' },
      },
      {
        path: 'enem-estatisca',
        name: 'estatisticasEnem',
        component: estatisticasEnem,
        meta: { section_name: 'area_restrit', section_childname: 'area_enem', title: 'ESTATISTICAS' },
      },
      {
        path: 'enem-manual',
        name: 'manualEnem',
        component: manualEnem,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_enem',
          title: 'MANUAL ',
        },
      },

      // Banco de Livros
      {
        path: 'banco-de-livros-books',
        name: 'books',
        component: books,
        meta: {
          section_name: 'area_restrit',
          title: 'Banco de Livros',
        },
      },

      /* BANCO DE LIVROS - ENSINO INFANTIL */
      {
        path: 'banco-de-livros-infantil',
        name: 'bancoDeLivrosInfantil',
        component: booksInfantil,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_bancoDeLivros',
          title: 'Infantil',
        },
      },

      /* BANCO DE LIVROS - FUNDAMENTAL I */
      {
        path: 'banco-de-livros-fundamental-i',
        name: 'bancoDeLivrosFundamentalI',
        component: booksFundamentalI,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_bancoDeLivros',
          title: 'Ensino Fundamental I',
        },
      },
      {
        path: 'banco-de-livros-fundamental-i-1o-ano',
        name: 'bancoDeLivrosFundamentalI1Ano',
        component: booksFundamentalIPrimeiroAno,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_bancoDeLivros',
          section_thirdname: 'area_bancoDeLivrosFundamentalI',
          title: '1º Ano',
        },
      },
      {
        path: 'banco-de-livros-fundamental-i-2o-ano',
        name: 'bancoDeLivrosFundamentalI2Ano',
        component: booksFundamentalISegundoAno,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_bancoDeLivros',
          section_thirdname: 'area_bancoDeLivrosFundamentalI',
          title: '2º Ano',
        },
      },
      {
        path: 'banco-de-livros-fundamental-i-3o-ano',
        name: 'bancoDeLivrosFundamentalI3Ano',
        component: booksFundamentalITerceiroAno,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_bancoDeLivros',
          section_thirdname: 'area_bancoDeLivrosFundamentalI',
          title: '3º Ano',
        },
      },
      {
        path: 'banco-de-livros-fundamental-i-4o-ano',
        name: 'bancoDeLivrosFundamentalI4Ano',
        component: booksFundamentalIQuartoAno,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_bancoDeLivros',
          section_thirdname: 'area_bancoDeLivrosFundamentalI',
          title: '4º Ano',
        },
      },
      {
        path: 'banco-de-livros-fundamental-i-5o-ano',
        name: 'bancoDeLivrosFundamentalI5Ano',
        component: booksFundamentalIQuintoAno,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_bancoDeLivros',
          section_thirdname: 'area_bancoDeLivrosFundamentalI',
          title: '5º Ano',
        },
      },

      /* BANCO DE LIVROS - ENSINO FUNDAMENTAL II */
      {
        path: 'banco-de-livros-fundamental-ii',
        name: 'bancoDeLivrosFundamentalII',
        component: booksFundamentalII,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_bancoDeLivros',
          title: 'Fundamental II',
        },
      },
      {
        path: 'banco-de-livros-fundamental-ii-6o-ano',
        name: 'bancoDeLivrosFundamentalII6Ano',
        component: booksFundamentalIISextoAno,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_bancoDeLivros',
          section_thirdname: 'area_bancoDeLivrosFundamentalII',
          title: '6º Ano',
        },
      },
      {
        path: 'banco-de-livros-fundamental-ii-7o-ano',
        name: 'bancoDeLivrosFundamentalII7Ano',
        component: booksFundamentalIISetimoAno,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_bancoDeLivros',
          section_thirdname: 'area_bancoDeLivrosFundamentalII',
          title: '7º Ano',
        },
      },
      {
        path: 'banco-de-livros-fundamental-ii-8o-ano',
        name: 'bancoDeLivrosFundamentalII8Ano',
        component: booksFundamentalIIOitavoAno,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_bancoDeLivros',
          section_thirdname: 'area_bancoDeLivrosFundamentalII',
          title: '8º Ano',
        },
      },
      {
        path: 'banco-de-livros-fundamental-ii-9o-ano',
        name: 'bancoDeLivrosFundamentalII9Ano',
        component: booksFundamentalIINonoAno,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_bancoDeLivros',
          section_thirdname: 'area_bancoDeLivrosFundamentalII',
          title: '9º Ano',
        },
      },

      /* BANCO DE LIVROS - ENSINO MÉDIO */
      {
        path: 'banco-de-livros-ensino-medio',
        name: 'bancoDeLivrosEnsinoMedio',
        component: booksEnsinoMedio,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_bancoDeLivros',
          title: 'Ensino Médio',
        },
      },
      {
        path: 'banco-de-livros-ensino-medio-1o-ano',
        name: 'bancoDeLivrosEnsinoMedio1Ano',
        component: booksEnsinoMedioPrimeiroAno,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_bancoDeLivros',
          section_thirdname: 'area_bancoDeLivrosEnsinoMedio',
          title: '1º Ano',
        },
      },
      {
        path: 'banco-de-livros-ensino-medio-2o-ano',
        name: 'bancoDeLivrosEnsinoMedio2Ano',
        component: booksEnsinoMedioSegundoAno,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_bancoDeLivros',
          section_thirdname: 'area_bancoDeLivrosEnsinoMedio',
          title: '2º Ano',
        },
      },
      {
        path: 'banco-de-livros-ensino-medio-3o-ano',
        name: 'bancoDeLivrosEnsinoMedio3Ano',
        component: booksEnsinoMedioTerceiroAno,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_bancoDeLivros',
          section_thirdname: 'area_bancoDeLivrosEnsinoMedio',
          title: '3º Ano',
        },
      },

      // solucoes - super-pro e 24h
      { path: 'redireciona-super-pro', name: 'acessoSuperPro', component: acessoSuperPro },
      { path: 'login-24h', name: 'e_24h', component: e24h },
      { path: 'nao-autorizado', component: erro503, name: 'erro503', meta: { layout: 'landing' } },
      {
        path: 'atendimento-digital',
        name: 'atendimentoDigital',
        component: atendimentoDigital,
        meta: { section_name: 'area_restrit', title: 'Atendimento Digital' },
      },
      { path: 'Sucesso/:nome', name: 'thanks', component: thanks },
    ],
  },


  {
    path: '/admin-super-pro',
    name: 'adminSuperPro',
    component: adminSuperPro,
    meta: { section_name: 'area_restrit', title: 'Administração Super PRO' },
    children: [
      {
        path: 'users-superpro',
        name: 'users-superpro',
        component: userIndex,
        meta: { section_name: 'area_restrit', section_childname: 'area_superpro', title: 'Usuários' },
        children: [
          {
            path: 'lista-usuarios',
            name: 'listaUsuarios',
            component: listaUsuarios,
            meta: { section_name: 'area_restrit', section_childname: 'area_superpro', title: 'Lista de Usuários' },
          },
          {
            path: 'criar-usuario',
            name: 'criaUsuarioSuperPro',
            component: criaUsuarioSuperPro,
            meta: {
              section_name: 'area_restrit',
              section_childname: 'area_superpro',
              title: 'Cadastro de Usuário',
            },
          },
          {
            path: 'editar-usuario',
            name: 'editarUsuarioSuperPro',
            component: editaUsuarioSuperPro,
            meta: {
              section_name: 'area_restrit',
              section_childname: 'area_superpro',
              title: 'Editar Usuário',
            },
          },
          {
            path: 'cadastrar-credito',
            name: 'cadastrarCreditoEscolaSuperPro',
            component: cadastrarCreditoSuperPro,
            meta: { section_name: 'area_restrit', section_childname: 'area_superpro', title: 'Cadastrar Crédito' },
          },
          {
            path: 'consultar-credito',
            name: 'consultarCreditoSuperPro',
            component: consultarCreditoSuperPro,
            meta: { section_name: 'area_restrit', section_childname: 'area_superpro', title: 'Consultar Crédito' },
          },
          {
            path: 'estornar-credito',
            name: 'estornarCreditoSuperPro',
            component: extornarCreditoSuperPro,
            meta: { section_name: 'area_restrit', section_childname: 'area_superpro', title: 'Extornar Crédito' },
          },
          {
            path: 'excluir-usuario',
            name: 'excluiUsuarioSuperPro',
            component: excluiUsuarioSuperPro,
            meta: { section_name: 'area_restrit', section_childname: 'area_superpro', title: 'Excluir de Usuário' },
          },
    

        ],
      },
      {
        path: 'schools-superpro',
        name: 'schools-superpro',
        component: schoolIndex,
        meta: { section_name: 'area_restrit', section_childname: 'area_superpro', title: 'Usuários' },
        children: [
          {
            path: 'lista-escolas',
            name: 'listaEscola',
            component: listaEscola,
            meta: { section_name: 'area_restrit', section_childname: 'area_superpro', title: 'Lista de Escolas' },
          },
          {
            path: 'cadastrar-escola',
            name: 'cadastrarEscolaSuperPro',
            component: cadastrarEscolaSuperPro,
            meta: { section_name: 'area_restrit', section_childname: 'area_superpro', title: 'Cadastrar Escola' },
          },
          {
            path: 'estornar-credito-escola',
            name: 'estornarCreditoEscolaSuperPro',
            component: extornarCreditoEscolaSuperPro,
            meta: {
              section_name: 'area_restrit',
              section_childname: 'area_superpro',
              title: 'Extornar Crédito - Escola',
            },
          },
        ],
      },
      {
        path: 'lincar-usuario-spw',
        name: 'vincularUsuario',
        component: lincarUsuarioSpwSuperPro,
        meta: {
          section_name: 'area_restrit',
          section_childname: 'area_superpro',
          title: 'Lincar usuario do sistema com superPro'
        },
      },
    ],
  },



  {
    path: '/admin-e24h',
    name: 'dash-e24h',
    component: e24hRegisterUser,
    meta: { layout: 'auth', section_name: 'area_restrit'  },
    children: [ 
      {
        path: 'habilitar-usuario-e24h',
        name: 'habilitaUsuarioE24h',
        component: habilitaUserSistemaComE24h,
        meta: { layout: 'auth', section_name: 'area_restrit', section_childname: 'area_e24h', title: 'Habilitar usuário e-24h' },
      },
    ],
  },

  // {
  //     path: '/cadastro',
  //     name: 'cadastro',
  //     component: register,
  //     meta: { layout: 'auth' },
  //     children: [
  //         { path: 'responsavel', name: 'registerResp', component: registerResp, meta: { layout: 'auth' } },
  //         {
  //             path: 'coloborador',
  //             name: 'registerColoborador',
  //             component: registerColoborador,
  //             meta: { layout: 'auth' },
  //         },
  //         { path: 'codigo', name: 'registerCodigo', component: underMaitence, meta: { layout: 'auth' } },
  //     ],
  // },

  //auth
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/auth/login.vue'),
    meta: { layout: 'auth' },
  },
  {
    path: '/cadastro/:company_id',
    name: 'cadastro',
    component: () => import(/* webpackChunkName: "cadastro" */ '../views/auth/cadastro.vue'),
    meta: { layout: 'auth' },
    props: true,
    children: [
      { 
        path: 'cadastrar-responsavel', 
        name: 'registerResp', 
        component: registerResp, 
        meta: { layout: 'auth' }, 
        props: true
      },
     
        
      {
        path: 'cadastrar-colaborador',
        name: 'registerColoborador',
        component: registerColoborador,
        meta: { layout: 'auth' },
           props: true
      },
      { path: 'codigo', name: 'registerCodigo', component: underMaitence, meta: { layout: 'auth' },   props: true},
    ],
  },

  {
    path: '/auth/lockscreen',
    name: 'lockscreen',
    component: () => import(/* webpackChunkName: "lockscreen" */ '../views/auth/lockscreen.vue'),
    meta: { layout: 'auth' },
  },
  {
    path: '/auth/pass-recovery',
    name: 'pass-recovery',
    component: () => import(/* webpackChunkName: "pass-recovery" */ '../views/auth/pass_recovery.vue'),
    meta: { layout: 'auth' },
  },

    {
    path: '/auth/pass_new_user',
    name: 'pass-new-user',
    component: () => import( '../views/auth/pass_new_user.vue'),
    meta: { layout: 'auth' },
  },

  {
    path: '/auth/pass-recovery-update/:token',
    name: 'pass-recovery-update',
    component: passwordUpdate,
    meta: { layout: 'auth' },
  },

  //user
  {
    path: '/users/profile',
    name: 'profile',
    component: () => import(/* webpackChunkName: "profile" */ '../views/users/profile.vue'),
    meta: { layout: 'auth' },
  },
  {
    path: '/users/account-setting',
    name: 'account-setting',
    component: () => import(/* webpackChunkName: "account-setting" */ '../views/users/account_setting.vue'),
    meta: { layout: 'auth' },
  },

  //users
  {
    path: '/users',
    name: 'users',
    component: () => import(/* webpackChunkName: "users-users" */ '../views/users/index.vue'),
    // meta: { section_name: 'users' },
    // meta: { layout: 'auth' },
    props: true,
  },
  {
    path: '/users/new',
    name: 'new-user',
    component: () => import(/* webpackChunkName: "new-user" */ '../views/users/create-user.vue'),
    //meta: { section_name: 'users' },
    //meta: { layout: 'auth' },
    props: true,
  },
  {
    path: '/users/:userId/edit',
    name: 'edit-user',
    component: () => import(/* webpackChunkName: "edit-user" */ '../views/users/create-user.vue'),
    // meta: { section_name: 'users' },
    // meta: { layout: 'auth' },
    props: true,
  },
  //schools
  {
    path: '/schools',
    name: 'schools',
    component: () => import(/* webpackChunkName: "users-schools" */ '../views/schools/index.vue'),
    meta: { section_name: 'schools' },
    props: true,
  },
  {
    path: '/school/:schoolId',
    name: 'school',
    component: () => import(/* webpackChunkName: "users-schools" */ '../views/schools/school.vue'),
    meta: { section_name: 'school' },
    props: true,
  },

  {
    path: '/schools-classes',
    name: 'schoolsClasses',
    component: () => import('../views/schools/school-classes.vue'),
    meta: { section_name: 'schools' },
    props: true,
  },

  {
    path: '/schools-classes-turmas',
    name: 'schoolsClassesTurmas',
    component: () => import('../views/schools/school-classes-turmas.vue'),
    meta: { section_name: 'schools' },
    props: true,
  },

  {
    path: '/schools/new',
    name: 'create-school',
    component: () => import(/* webpackChunkName: "create-school" */ '../views/schools/create-school.vue'),
    meta: { section_name: 'schools' },
    props: true,
  },

  {
    path: '/schools/:schoolId/edit',
    name: 'edit-school',
    component: () => import(/* webpackChunkName: "edit-school" */ '../views/schools/edit-school.vue'),
    meta: { section_name: 'schools' },
    props: true,
  },
  {
    path: '/schools/:schoolId/turma/:turmaId/:schoolNome?/:schoolCnpj?/studants',
    name: 'students',
    component: () =>
      import(/* webpackChunkName: "edit-school" */ '../views/schools/turma/students/view-students-list-turma.vue'),
    meta: { section_name: 'Escola' },
    props: true,
  },
  //admin
  {
    path: '/admin/subscription/subscriptions',
    name: 'subscriptions',
    component: () => import(/* webpackChunkName: "subscriptions" */ '../views/admin/subscriptions/subscriptions.vue'),
  },
  {
    path: '/admin/subscription/plans',
    name: 'subscription-plans',
    component: () => import(/* webpackChunkName: "subscription-plans" */ '../views/admin/subscriptions/plans.vue'),
  },
  {
    path: '/admin/subscription/new-plan',
    name: 'new-subscription-plan',
    component: () => import(/* webpackChunkName: "new-subscription-plan" */ '../views/admin/subscriptions/plan.vue'),
  },
  {
    path: '/admin/subscription/plan/:planId',
    name: 'edit-subscription-plan',
    component: () => import(/* webpackChunkName: "edit-subscription-plan" */ '../views/admin/subscriptions/plan.vue'),
    props: true,
  },
  {
    path: '/admin/storage/aws-s3',
    name: 'admin-storage-aws-s3',
    component: () => import(/* webpackChunkName: "admin-storage-aws-s3" */ '../views/admin/aws-s3/aws-s3-tools.vue'),
    props: true,
  },
]
export default routes
